/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { Select } from 'ember-power-select/components/power-select';
import { action } from '@ember/object';
import SegmentModel from 'cio/models/segment';

interface EditorArgs {
  selectedSegments?: SegmentModel[];
  disabled?: boolean;
  dropdownInitiallyOpened?: boolean;
  segments?: SegmentModel[];
  marginClass?: string;
  dropdownClass?: string;
  variation?: string;
  canCreateSegment?: boolean;
  onChange: (newSegments: SegmentModel[]) => unknown;
}

export default class Editor extends Component<EditorArgs> {
  @action
  onChange(segments: SegmentModel[], select: Select) {
    this.args.onChange(segments);
    select.actions.close();
  }
}
